import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ClientsModule } from './modules/clients/clients.module';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { DateSerializerInterceptor } from './core/interceptors/date-serializer.interceptor';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoginComponent } from './modules/auth/components/login/login.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DeleteConfirmDialogComponent } from './shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CasesModule } from './modules/cases/cases.module';
import { DiariesModule } from './modules/diaries/diaries.module';
import { DistrictsModule } from './modules/districts/districts.module';
import { CourtTypesModule } from './modules/court-types/court-types.module';
import { CaseTypesModule } from './modules/case-types/case-types.module';
import { TransactionsModule } from './modules/transactions/transactions.module';
import { TodosModule } from './modules/todos/todos.module';
import { ExpensesModule } from './modules/expenses/expenses.module';
import { FileUploaderComponent } from './shared/components/file-uploader/file-uploader.component';
import { APP_DATE_FORMATS, AppDateAdapter } from './core/adapters/custom-date-adapter';
@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    ClientsModule,
    MatFormFieldModule,   // 👈 Add this
    MatInputModule,       // 👈 Add this
    MatButtonModule,      // 👈 Add this
    MatSnackBarModule,     // 👈 A
    MatPaginatorModule,
    MatProgressBarModule,
    CasesModule,
    DiariesModule,
    DistrictsModule,
    CourtTypesModule,
    CaseTypesModule,
    TransactionsModule,
    TodosModule,
    ExpensesModule,
    FileUploaderComponent // ADD here
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LoginComponent,
    DeleteConfirmDialogComponent,

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DateSerializerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' } // ensures dd/MM/yyyy convention
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
